import {axiosInstance} from "../boot/axios";

export async function getURL() {
    return await axiosInstance.get("/api/ccn-redirect")
}
